import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { Button, FlexibleModal, TextInput } from 'components'
import ApiHelper from 'helpers/ApiHelper'

const AdminTenantCreateModal = ({ visible, toggle }) => {
  const { t } = useTranslation()
  const [form, setForm] = useState({})

  //  --- Functionality ---
  const closeModal = () => {
    setForm({})
    toggle()
  }

  const createTenant = async () => {
    const body = {
      name: form.name,
      primaryDomain: form.primaryDomain,
      adminId: null,
    }
    await toast.promise(ApiHelper.createTenant(body), {
      loading: 'Creating new tenant',
      success: 'Tenant created',
      error: 'Could not create tenant',
    })

    closeModal()
  }

  const isDisabled = () => {
    return !(form.name && form.primaryDomain)
  }

  //  --- Response ---
  return (
    <FlexibleModal size="modal-md" visible={visible}>
      <div className="flex flex-col space-y-4">
        <div className="flex flex-col space-y-4">
          <label className="flex justify-between">
            <p className="my-auto">Name</p>
            <TextInput
              className="w-2/3"
              onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
              value={form.name}
            />
          </label>
          <label className="flex justify-between">
            <p className="my-auto">Primary domain</p>
            <TextInput
              className="w-2/3"
              onChange={(e) =>
                setForm((f) => ({ ...f, primaryDomain: e.target.value }))
              }
              value={form.primaryDomain}
            />
          </label>
        </div>
        <div className="flex flex-row justify-end space-x-4">
          <Button
            className="border border-red-200 bg-white text-red-500 hover:border-red-500 hover:bg-red-500 hover:text-white"
            onClick={closeModal}
          >
            {t('application:cancel')}
          </Button>
          <Button
            disabled={isDisabled()}
            className="bg-green-400 text-white hover:bg-green-500"
            onClick={createTenant}
          >
            {t('application:submit')}
          </Button>
        </div>
      </div>
    </FlexibleModal>
  )
}

export default AdminTenantCreateModal
